module.exports = __webpack_public_path__ + "static/media/material-ui.b44125bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/material-ui.png
// module id = 37
// module chunks = 0